module.exports = __webpack_public_path__ + "img/conimg2-03.1ce7bd7b.png";